import { render, staticRenderFns } from "./trev-job-reports-quick-links-bar.vue?vue&type=template&id=9b9bc692&"
import script from "./trev-job-reports-quick-links-bar.vue?vue&type=script&lang=js&"
export * from "./trev-job-reports-quick-links-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VToolbar})
